import React from "react";
import HeroCard from "@/components/heroCard";
import { CONCLUSION_CONSTANTS } from "./constants";

const BuyCta = () => {
  return (
    <HeroCard backgroundImage="/bare-metal/pricingConc.png" {...CONCLUSION_CONSTANTS} />
  );
};

export default BuyCta;
